import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FullPageLoader } from "./common/FullPageLoader";

export function ProtectedRoute({ children }) {
  const { isAuthenticated, isBootstrapping, organization } = useAuth();
  const location = useLocation();

  if (isBootstrapping || (isAuthenticated && !organization)) {
    return <FullPageLoader title="Loading your workspace" subtitle="Restoring session and organization context." />;
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (!organization?.onboardingCompleted && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
